// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r5uF","toggleWrap":"styles_toggleWrap__3Jl59","content":"styles_content__2_c5U","selectAreaCode":"styles_selectAreaCode__3KMYZ"};